
import React from 'react';
import StatusUpdateDialog from './StatusUpdateDialog';
import AddEmployeeDialog from '../AddEmployeeDialog';
import AddClientDialog from '../AddClientDialog';
import EditClientDialog from '../EditClientDialog';

interface AdminDialogContainerProps {
  isDialogOpen: boolean;
  setIsDialogOpen: (open: boolean) => void;
  selectedRequest: any;
  newStatus: string;
  setNewStatus: (status: string) => void;
  isProcessing: boolean;
  updateRequestStatus: () => void;
  isAddEmployeeOpen: boolean;
  setIsAddEmployeeOpen: (open: boolean) => void;
  fetchEmployees: () => void;
  isAddClientOpen: boolean;
  setIsAddClientOpen: (open: boolean) => void;
  handleAddClient: (clientData: any) => Promise<void>;
  isEditClientOpen: boolean;
  setIsEditClientOpen: (open: boolean) => void;
  clientToEdit: any;
  updateClient: (clientData: any) => void;
}

const AdminDialogContainer: React.FC<AdminDialogContainerProps> = ({
  isDialogOpen,
  setIsDialogOpen,
  selectedRequest,
  newStatus,
  setNewStatus,
  isProcessing,
  updateRequestStatus,
  isAddEmployeeOpen,
  setIsAddEmployeeOpen,
  fetchEmployees,
  isAddClientOpen,
  setIsAddClientOpen,
  handleAddClient,
  isEditClientOpen,
  setIsEditClientOpen,
  clientToEdit,
  updateClient
}) => {
  console.log('AdminDialogContainer rendered with:', {
    isEditClientOpen,
    hasClientToEdit: !!clientToEdit,
    clientToEditId: clientToEdit?.id || 'none',
    clientToEditType: clientToEdit?.wave_customer_id ? 'Wave Import' : 'Regular'
  });

  return (
    <>
      <StatusUpdateDialog
        isOpen={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        selectedRequest={selectedRequest}
        newStatus={newStatus}
        setNewStatus={setNewStatus}
        isProcessing={isProcessing}
        updateRequestStatus={updateRequestStatus}
      />

      <AddEmployeeDialog
        isOpen={isAddEmployeeOpen}
        onOpenChange={setIsAddEmployeeOpen}
        onEmployeeAdded={fetchEmployees}
      />

      <AddClientDialog
        isOpen={isAddClientOpen}
        onOpenChange={setIsAddClientOpen}
        onClientAdded={handleAddClient}
        isProcessing={isProcessing}
      />

      <EditClientDialog
        isOpen={isEditClientOpen}
        onOpenChange={(open) => {
          console.log('EditClientDialog onOpenChange called with:', open);
          setIsEditClientOpen(open);
        }}
        client={clientToEdit}
        onClientUpdated={updateClient}
        isProcessing={isProcessing}
      />
    </>
  );
};

export default AdminDialogContainer;
